module.exports = ".folded:not(.folded-open) :host .nav-link > .nav-link-title,\n.folded:not(.folded-open) :host .nav-link > .nav-link-badge {\n  opacity: 0;\n  -webkit-transition: opacity 200ms ease;\n  transition: opacity 200ms ease; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/navigation/vertical/nav-item/nav-vertical-item.component.scss
// module id = ./src/app/core/components/navigation/vertical/nav-item/nav-vertical-item.component.scss
// module chunks = main